import { GenericMessage } from "../../lib/messages";
export class NavMessage extends GenericMessage {
}
